<template>
  <div>
    <div class="sidebar_container">
      <div class="sidebar_header">
        <CRow class="m-0">
          <CCol cols="10" class="text-left">
            <span v-if="history.length > 1" class="pointer" @click="removeSidebarHistoryStep()">
              <i class="fas fa-arrow-circle-left mr-1"/>
            </span>
            <span class="sidebar_subject">
              {{$t('lms.Preview_course')}}
            </span>
          </CCol>
          <CCol cols="2" class="text-right">
            <span @click="closeSidebarRight();"><i class="fas fa-times"/></span>
          </CCol>
        </CRow>
      </div>
      <div class="sidebar_content">
        <CRow class="m-0">
          <CCol cols="12" class="pt-0">
            <CCard class="mb-0 course_preview_card">
              <CCardBody class="p-0">
                <!-- Course -->
                <div v-if="viewMode === 'course'">
                  <div class="card_header">
                    <div v-if="course.image_id && course.from_marketplace === 'N'" class="card_header_background">
                      <img :src="apiBaseUrl + '/v1/common/cdn/file/image/learn-course/' + course.lms_course_id_external + '/' + course.image_id + '.jpg' + '/' + clientToken"/>
                    </div>
                    <div v-else-if="course.image_id && course.from_marketplace === 'Y'" class="card_header_background">
                      <img :src="apiBaseUrl + '/v1/common/cdn/file/image/learn-course-mp/' + course.lms_course_id_external + '/' + course.image_id + '.jpg' + '/' + clientToken"/>
                    </div>
                    <div v-if="course.image_id && course.from_marketplace === 'N'" 
                        :style="{ backgroundImage: 'url(' + apiBaseUrl + '/v1/common/cdn/file/image/learn-course/' + course.lms_course_id_external + '/' + course.image_id + '.jpg' + '/' + clientToken + ')' }"
                        class="h-100 w-100 card_image">
                    </div>
                    <div v-else-if="course.image_id && course.from_marketplace === 'Y'" 
                        :style="{ backgroundImage: 'url(' + apiBaseUrl + '/v1/common/cdn/file/image/learn-course-mp/' + course.lms_course_id_external + '/' + course.image_id + '.jpg' + '/' + clientToken + ')' }"
                        class="h-100 w-100 card_image">
                    </div>
                    <div v-else class="h-100 w-100 d-flex align-items-center justify-content-center card_icon">
                      <i class="fa-solid fa-user-graduate"/>
                    </div>
                    <div class="badges">
                      <b-tag class="p-3">
                        <span v-line-clamp="1">{{course.course_category_name}}</span>
                      </b-tag>
                    </div>
                  </div>
                  <div class="card_details">
                    <div class="d-flex align-items-center pt-2_5 pl-2_5 pr-2_5 pb-2">
                      <div class="flex-grow-1">
                        <h3 v-line-clamp="1" class="m-0"><b>{{course.course_name}}</b></h3>
                      </div>
                    </div>
                    <div class="meta d-flex align-items-center pt-0 pl-2_5 pr-2_5">
                      <span v-if="course.points > 0" class="d-flex align-items-center mr-2 credits">
                        <img v-if="environmentTag" :src="apiBaseUrl + '/v1/common/cdn/file/image/base-app/credits/' + environmentTag + '_credit.png/' + clientToken"/>
                        <span>{{course.points}}</span>
                      </span>
                      <span class="mr-2"><i class="fas fa-clock mr-1"/>{{course.total_duration}} {{course.total_duration !== 1 ? $t('common.minutes') : $t('common.minute')}}</span>
                      <span><i class="fas fa-book mr-1"/>{{course.nr_of_chapters}} {{course.nr_of_chapters !== 1 ? $t('common.chapters') : $t('common.chapter')}}</span>
                    </div>
                    <div>
                      <b-tabs class="no_borders mb-0" type="is-boxed" :animated="false" v-model="activeCourseTab">
                        <b-tab-item v-if="course.description">
                          <template slot="header">
                            <span>{{$t('common.Description')}}</span>
                          </template>
                          <template>
                            <CRow class="m-0">
                              <CCol cols="12" class="p-0">
                                <span class="text_container" v-html="course.description"></span>
                              </CCol>
                            </CRow>
                          </template>
                        </b-tab-item>
                        <b-tab-item v-if="course.objectives">
                          <template slot="header">
                            <span>{{$t('lms.Objectives')}}</span>
                          </template>
                          <template>
                            <CRow class="m-0">
                              <CCol cols="12" class="p-0">
                                <span class="text_container" v-html="course.objectives"></span>
                              </CCol>
                            </CRow>
                          </template>
                        </b-tab-item>
                        <b-tab-item v-if="course.chapters">
                          <template slot="header">
                            <span>{{ $t('common.Chapters')}}</span>
                          </template>
                          <template>
                            <CRow class="m-0 course_chapters">
                              <CCol cols="12" class="p-0">
                                <b-collapse v-for="chapter in course.chapters" :key="chapter.lms_chapter_id" class="panel dashboard show" :open="false">
                                  <div slot="trigger" slot-scope="props" class="panel-heading p-0" role="button">
                                    <CRow class="w-100 m-0 align-items-center">
                                      <CCol cols="12" class="d-flex">
                                        <div @click.stop="openChapter(chapter)" class="pointer">
                                          <span class="course_chapter_title">{{chapter.chapter_name}}</span>
                                        </div>
                                        <div class="flex-grow-1 text-right pl-3">
                                          <i class="fas" :class="{'fa-chevron-up': props.open, 'fa-chevron-down': !props.open}"></i>
                                        </div>
                                      </CCol>
                                    </CRow>
                                  </div>
                                  <div class="panel-block p-0">
                                    <div v-for="step in chapter.steps" :key="step.lms_step_id_external" @click.stop="openStep(step, 'course')" class="step w-100 p-2_5">
                                      <div class="d-flex align-items-center pointer">
                                        <div class="flex-grow-1">
                                          <span>{{step.step_name}}</span>
                                        </div>
                                        <div class="text-right">
                                          <i class="fa-solid fa-angle-right"></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </b-collapse>
                              </CCol>
                            </CRow>
                          </template>
                        </b-tab-item>
                      </b-tabs>
                    </div>
                  </div>
                </div>
                <!-- Chapter -->
                <div v-if="viewMode === 'chapter' && selectedChapter" class="p-2_5">
                  <div class="card_details">
                    <div class="d-flex align-items-center mb-2">
                      <div class="flex-grow-1">
                        <h3 v-line-clamp="1" class="m-0"><b>{{selectedChapter.chapter_name}}</b></h3>
                      </div>
                    </div>
                    <div class="meta d-flex align-items-center" :class="{'mb-2_5' : selectedChapter.description}">
                      <span class="mr-2"><i class="fas fa-shoe-prints mr-1"/>{{selectedChapter.nr_of_steps > 1 ? selectedChapter.nr_of_steps + ' ' + $t('common.steps') : selectedChapter.nr_of_steps + ' ' + $t('common.step')}}</span>                      
                      <span><i class="fas fa-clock mr-1"/>{{selectedChapter.duration}} {{selectedChapter.duration !== 1 ? $t('common.minutes') : $t('common.minute')}}</span>
                    </div>                  
                    <div v-if="selectedChapter.description" class="d-flex align-items-center">
                      <p class="text_container m-0" v-html="selectedChapter.description"></p>
                    </div>
                  </div>
                </div>
                <!-- Step -->            
                <div v-if="viewMode === 'step' && selectedStep" class="p-2_5">
                  <div class="card_details">
                    <div class="d-flex align-items-center mb-2">
                      <div class="flex-grow-1">
                        <h3 v-line-clamp="1" class="m-0"><b>{{selectedStep.step_name}}</b></h3>
                      </div>
                    </div>
                    <div class="meta d-flex align-items-center mb-1" :class="{'mb-1' : selectedStep.description, 'mb-2_5' : !selectedStep.description}">                                       
                      <span><i class="fas fa-clock mr-1"/>{{selectedStep.duration}} {{selectedStep.duration !== 1 ? $t('common.minutes') : $t('common.minute')}}</span>
                    </div>                    
                    <div v-if="selectedStep.description" class="text_container description" :class="{'mb-2_5' : selectedStep.step_type_tag !== 'waiting_period'}">
                      <p class="text_container m-0" v-html="selectedStep.description"></p>
                    </div>
                    
                    <div v-if="selectedStep.step_type_tag === 'audio'" class="w-100">
                      <div v-if="stepAudioEnded === false">
                        <div v-if="selectedStep.step_audio_file_id && selectedChapter.from_marketplace === 'N'">
                          <audioPlayer :standalone="true"
                                      :audioFileName="null"
                                      :audioSourceUrl="apiBaseUrl + '/v1/common/cdn/file/mp3/learn-course/' + selectedStep.lms_course_id_external + '/' + selectedStep.step_audio_file_id + '/' + clientToken"
                                      :audioSourceDownloadable="false">
                          </audioPlayer>
                        </div>
                        <div v-else-if="selectedStep.step_audio_file_id && selectedChapter.from_marketplace === 'Y'">
                          <audioPlayer :standalone="true"
                                      :audioFileName="null"
                                      :audioSourceUrl="apiBaseUrl + '/v1/common/cdn/file/mp3/learn-course-mp/' + selectedStep.lms_course_id_external + '/' + selectedStep.step_audio_file_id + '/' + clientToken"
                                      :audioSourceDownloadable="false">
                          </audioPlayer>
                        </div>
                      </div>
                      <div v-show="stepAudioEnded === true" class="media_ended">
                        <i class="fas fa-check mt-1 mr-1"/>                
                        <p class="m-0">{{$t('lms.Audio_ended_next_step')}}</p>
                      </div>                  
                    </div>                    
                    <div v-if="selectedStep.step_type_tag === 'video'" class="w-100">
                      <div v-if="stepVideoEnded === false" class="video_container">              
                        <div v-for="video in selectedStep.step_videos.slice(0, 1)" v-bind:key="video.lms_step_video_id" class="w-100">
                          <div v-if="video.video_available === 'Y'">
                            <div v-if="video.video_provider_tag === 'youtube'" class="youtube_video_container">
                              <youtube :video-id="video.provider_video_id" ref="youtube" :player-vars="playerVars" :fitParent="true" @ended="stepVideoEnded = true;" class="w-100"></youtube>            
                            </div>
                            <div v-if="video.video_provider_tag === 'dyntube'" class="dyntube_video_container">
                              <div v-if="video.provider_channel_key" :data-dyntube-key="video.provider_channel_key"></div>
                            </div>
                          </div>
                          <videoPlaceholder v-else emoji="📹" :content="$t('common.Video_almost_available')"/>
                        </div>
                      </div>                  
                      <div v-show="stepVideoEnded === true" class="media_ended">
                        <i class="fas fa-check mt-1 mr-1"/>                
                        <p class="m-0">{{$t('lms.Video_ended_next_step')}}</p>                
                      </div>
                    </div>
                    <div v-if="selectedStep.step_type_tag === 'text'" class="w-100">
                      <div class="text_container">
                        <p class="mt-0 mb-0 text" v-html="selectedStep.content"></p>
                      </div>
                    </div>
                    <div v-if="selectedStep.step_type_tag === 'external_link'" class="w-100">
                      <CButton color="secondary" @click="openExternalLink(selectedStep.content)" class="w-100">
                        <i class="fas fa-external-link-alt mr-1"/>{{$t('lms.Open_external_link')}}
                      </CButton>
                    </div>                    
                    <div v-if="selectedStep.step_type_tag === 'questions'" class="w-100">                
                      <div v-for="question in selectedStep.questions" v-bind:key="question.lms_question_id" class="question text_container mb-2_5">
                        <h3 class="mt-0 mb-1">{{$t('lms.Question')}}</h3>
                        <span><b>{{question.question}}</b></span>

                        <div class="answer_options mt-1">
                          <b-field v-for="(option, index) in question.answer_options" v-bind:key="index">  
                            <b-radio :native-value="option.lms_answer_option_id" v-model="question.lms_anwser_option_id" @input="questionAnswered = true">
                              {{option.answer}}
                            </b-radio>
                          </b-field>
                        </div>
                      </div>

                      <CButton color="secondary" @click="insertAnswers(selectedStep.questions);" class="w-100" v-bind:class="{correct_answer : showCorrectAnswer}" :disabled="questionAnswered === false">
                        {{ showCorrectAnswer ? $t('lms.Correct_answer') : $t('lms.Check_answer') }}
                      </CButton>

                      <b-modal :can-cancel="['x']" :active.sync="answerIncorrectModal" :width="960" scroll="keep">
                        <CCard class="mb-0">
                          <CCardBody>
                            <CRow>
                              <CCol cols="12" lg="12" class="pt-0 pb-0">
                                <span>{{questionFeedback}}</span>
                              </CCol>
                            </CRow>
                          </CCardBody>
                          <CCardFooter>
                            <CButton color="secondary" @click="answerIncorrectModal = false">
                              <i class="fas fa-times mr-1"/>{{ $t('close') }}
                            </CButton>
                          </CCardFooter>
                        </CCard>
                      </b-modal>
                    </div>
                    <div v-if="selectedStep.step_type_tag === 'h5p'" class="w-100">                                     
                      <vue-h5p :key="'h5p-' + selectedStep.lms_step_id_external" id="h5pIframe" :src="cdnBaseUrl + '/lms/' + selectedStep.h5p.owner_company_id_external + '/' + selectedStep.lms_course_id_external + '/' + selectedStep.h5p.source" @xapi="handleXAPIEvent($event)">
                        Loading...
                        <template #error>             
                          Resource not available.
                        </template>
                      </vue-h5p>          
                    </div>
                    <div v-if="selectedStep.step_type_tag === 'qr'" class="w-100">
                      <div class="qr_scanner">
                        <qrcode-stream @decode="onDecode"></qrcode-stream>
                      </div>

                      <b-modal :can-cancel="['x']" :active.sync="qrCodeResultModal" :width="960" scroll="keep">
                        <CCard class="mb-0">
                          <CCardBody>
                            <CRow>
                              <CCol cols="12" lg="12" class="pt-0 pb-0">
                                <span class="d-block mb-2_5">{{$t('lms.Scanned_location')}}</span>
                                <span class="d-block mb-2_5"><strong>{{qrCodeValue}}</strong></span>
                                <span>{{$t('lms.Scanned_correctly')}}</span>
                              </CCol>
                            </CRow>
                          </CCardBody>
                          <CCardFooter>
                            <CButton color="secondary" @click="qrCodeResultModal = false; qrCodeScanned = false;">
                              <i class="fas fa-play-circle mr-1"/>{{$t('lms.Scan_again')}}
                            </CButton>
                          </CCardFooter>
                        </CCard>
                      </b-modal>
                    </div>
                  </div>
                </div>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div>
      <div class="sidebar_footer">
        <CRow class="m-0">
          <CCol cols="8" xl="8" lg="8" md="8">
            <!-- Course overview: start de cursus -->
            <CButton v-if="viewMode === 'course' && firstChapter" color="primary" class="mr-2" @click="startCourse">
              <span><i class="fa fa-play mr-1"/>{{$t('lms.Start_course')}}</span>
            </CButton>
            <!-- Chapter overview: terug naar cursus en start hoofdstuk -->
            <template v-if="viewMode === 'chapter' && selectedChapter">
              <CButton color="secondary" class="mr-2" @click="backToCourse">
                <span><i class="fa fa-arrow-left mr-1"/>{{$t('lms.Back_to_course')}}</span>
              </CButton>
              <CButton v-if="firstStep" color="primary" @click="startChapter">
                <span><i class="fa fa-play mr-1"/>{{$t('lms.Start_chapter')}}</span>
              </CButton>
            </template>
            <!-- Step view: navigatie tussen stappen/hoofdstukken/cursus -->
            <template v-if="viewMode === 'step' && selectedStep && selectedChapter">
              <!-- Enige stap van hoofdstuk -->
              <template v-if="isFirstStep && isLastStep">
                <CButton color="secondary" class="mr-2" @click="backToChapter">
                  <span><i class="fa fa-arrow-left mr-1"/>{{$t('lms.Back_to_chapter')}}</span>
                </CButton>
                <CButton v-if="!isLastChapter && nextChapter" color="primary" @click="goToNextChapter">
                  <span><i class="fa fa-arrow-right mr-1"/>{{$t('lms.Next_chapter')}}</span>
                </CButton>
                <CButton v-if="isLastChapter" color="primary" @click="backToCourse">
                  <span><i class="fa fa-book mr-1"/>{{$t('lms.Back_to_course')}}</span>
                </CButton>
              </template>
              <!-- Eerste stap van hoofdstuk, niet laatste -->
              <template v-else-if="isFirstStep && !isLastStep">
                <CButton color="secondary" class="mr-2" @click="backToChapter">
                  <span><i class="fa fa-arrow-left mr-1"/>{{$t('lms.Back_to_chapter')}}</span>
                </CButton>
                <CButton color="primary" @click="goToNextStep">
                  <span><i class="fa fa-arrow-right mr-1"/>{{$t('lms.Next_step')}}</span>
                </CButton>
              </template>
              <!-- Laatste stap van laatste hoofdstuk -->
              <template v-else-if="isLastStep && isLastChapter">
                <CButton color="secondary" class="mr-2" @click="goToPrevStep">
                  <span><i class="fa fa-arrow-left mr-1"/>{{$t('lms.Previous_step')}}</span>
                </CButton>
                <CButton color="primary" class="mr-2" @click="backToCourse">
                  <span><i class="fa fa-book mr-1"/>{{$t('lms.Back_to_course')}}</span>
                </CButton>
              </template>
              <!-- Laatste stap van NIET laatste hoofdstuk -->
              <template v-else-if="isLastStep && !isFirstStep && !isLastChapter">
                <CButton color="secondary" class="mr-2" @click="goToPrevStep">
                  <span><i class="fa fa-arrow-left mr-1"/>{{$t('lms.Previous_step')}}</span>
                </CButton>
                <CButton v-if="nextChapter" color="primary" @click="goToNextChapter">
                  <span><i class="fa fa-arrow-right mr-1"/>{{$t('lms.Next_chapter')}}</span>
                </CButton>
              </template>
              <!-- Overige stappen -->
              <template v-else-if="!isFirstStep && !isLastStep">
                <CButton color="secondary" class="mr-2" @click="goToPrevStep">
                  <span><i class="fa fa-arrow-left mr-1"/>{{$t('lms.Previous_step')}}</span>
                </CButton>
                <CButton color="primary" @click="goToNextStep">
                  <span><i class="fa fa-arrow-right mr-1"/>{{$t('lms.Next_step')}}</span>
                </CButton>
              </template>
            </template>
          </CCol>
          <CCol cols="4" xl="4" lg="4" md="4" class="text-right">
            <CButton color="secondary" @click="closeSidebarRight();">
              <i class="fas fa-times mr-1"/>{{$t('Dismiss')}}
            </CButton>
          </CCol>
        </CRow>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import videoPlaceholder from '@/components/common/videoPlaceholder.vue';
import audioPlayer from '@/components/common/audioPlayer.vue';

export default {
  name: 'coursePreview',
  props: ['history', 'lmsCourseIdExternal', 'lmsChapterIdExternal', 'lmsStepIdExternal'],
  components: {
    videoPlaceholder,
    audioPlayer
  },  
  data() {
    return {
      apiBaseUrl: null,
      cdnBaseUrl: null,
      clientToken: null,
      environmentTag: null,
      viewMode: null, // 'course', 'chapter', 'step'
      course: {},
      activeCourseTab: 0,
      selectedChapter: null,
      selectedStep: null,
      cameFromCourse: false,
      showCorrectAnswer: false,
      questionFeedback: '',      
      playerVars: { 
        autoplay: 0, 
        controls: 0,
        playsinline: 1
      },
      qrCodeValue: null,
      qrCodeScanned: false,
      qrCodeResultModal: false,
      questionAnswered: false,
      stepVideoEnded: false,
      stepAudioEnded: false,
      answerIncorrectModal: false
    }
  },
  computed: {
    firstChapter() {
      return this.course.chapters && this.course.chapters.length > 0 ? this.course.chapters[0] : null;
    },
    firstStep() {
      return this.selectedChapter && this.selectedChapter.steps && this.selectedChapter.steps.length > 0 ? this.selectedChapter.steps[0] : null;
    },
    currentStepIndex() {
      if(!this.selectedChapter || !this.selectedStep) return -1;
      return this.selectedChapter.steps.findIndex(s => s.lms_step_id === this.selectedStep.lms_step_id);
    },
    isFirstStep() {
      return this.currentStepIndex === 0;
    },
    isLastStep() {
      if(!this.selectedChapter || !this.selectedStep) return false;
      return this.currentStepIndex === this.selectedChapter.steps.length - 1;
    },
    nextChapter() {
      if(!this.course.chapters || !this.selectedChapter) return null;
      const idx = this.course.chapters.findIndex(c => c.lms_chapter_id === this.selectedChapter.lms_chapter_id);
      return idx >= 0 && idx < this.course.chapters.length - 1 ? this.course.chapters[idx + 1] : null;
    },
    isLastChapter() {
      if(!this.course.chapters || !this.selectedChapter) return false;
      const idx = this.course.chapters.findIndex(c => c.lms_chapter_id === this.selectedChapter.lms_chapter_id);
      return idx === this.course.chapters.length - 1;
    }
  },
  methods: {
    getCourseDetails() {    
      axios.get(process.env.VUE_APP_API_URL + '/v1/learn/course/' + this.lmsCourseIdExternal + '/preview')
      .then(res => {
        // Store the course data in the component state
        this.course = res.data.data;
        // Default to the first course tab
        this.activeCourseTab = 0;

        // If a step external ID is provided, open the corresponding step view directly
        if(this.lmsStepIdExternal) {
          // Search all chapters for the step with the given external ID
          for(const chapter of this.course.chapters) {
            const step = chapter.steps.find(s => s.lms_step_id_external === this.lmsStepIdExternal);
            if(step) {
              this.openStep(step, 'course');
              break;
            }
          }
        }
        // If a chapter external ID is provided (and no step), open the corresponding chapter view directly
        else if(this.lmsChapterIdExternal) {
          // Find the chapter with the given external ID
          const chapter = this.course.chapters.find(c => c.lms_chapter_id_external === this.lmsChapterIdExternal);
          if(chapter) this.openChapter(chapter);
        }
        // If neither is provided, show the course overview
        else {
          this.viewMode = 'course';
        }
      })
      .catch(err => {
        console.error(err);
      });
    },
    openChapter(chapter) {
      this.viewMode = 'chapter';
      this.selectedChapter = chapter;
      this.selectedStep = null;
    },
    openStep(step, from) {      
      const chapter = this.course.chapters.find(ch =>
        ch.steps.some(s => s.lms_step_id === step.lms_step_id)
      );

      if(chapter) this.selectedChapter = chapter;    
      this.cameFromCourse = (from === 'course');
      this.viewMode = 'step';
      this.selectedStep = step;
    },
    startCourse() {
      if(this.firstChapter) this.openChapter(this.firstChapter);
    },
    startChapter() {
      if(this.firstStep) this.openStep(this.firstStep, 'chapter');
    },
    goToNextStep() {
      if(!this.selectedChapter || !this.selectedStep) return;
      const idx = this.currentStepIndex;
      if(idx >= 0 && idx < this.selectedChapter.steps.length - 1) {
        this.openStep(this.selectedChapter.steps[idx + 1], 'chapter');
      }
    },
    goToPrevStep() {
      if(!this.selectedChapter || !this.selectedStep) return;
      const idx = this.currentStepIndex;
      if(idx > 0) {
        this.openStep(this.selectedChapter.steps[idx - 1], 'chapter');
      }
    },
    goToNextChapter() {
      if(this.nextChapter) this.openChapter(this.nextChapter);
    },
    backToCourse() {
      this.viewMode = 'course';
      this.selectedChapter = null;
      this.selectedStep = null;
      this.cameFromCourse = false;
    },
    backToChapter() {
      this.viewMode = 'chapter';
      this.selectedStep = null;
      this.cameFromCourse = false;
    },
    handleXAPIEvent(ev) {      
      // Reset iframe height na event
      this.$nextTick(() => {
        setTimeout(() => {
          const iframe = document.getElementById("h5pIframe");
          if(iframe && iframe.contentWindow && iframe.contentWindow.document.body) {
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
          }
        }, 300);
      });
    },
    insertAnswers(questionData) {
      let params = {};
      params.questions = questionData;
      params.only_check_answers = true;

      axios.post(process.env.VUE_APP_API_URL + '/v1/learn/questions/answer', params)
      .then(res => {        
        if(res.data.data.correct_answer === false) {
          this.questionFeedback = res.data.data.wrong_answer_notice;
          this.showCorrectAnswer = false;
          this.answerIncorrectModal = true;
        } else {
          this.showCorrectAnswer = true;   
          setTimeout(function(){
            this.showCorrectAnswer = false;
          }.bind(this), 500);
        }
      })
      .catch(err => {
        console.error(err); 
      });
    },
    onDecode(decodedString) {
      if(this.qrCodeScanned === false && decodedString) {
        this.qrCodeValue = null;        
        this.qrCodeValue = decodedString;
        this.qrCodeResultModal = true;        
        this.qrCodeScanned = true;
      }
    },        
    openExternalLink(url) {
      window.open(url, '_blank');
    }    
  },
  watch: {
    $props: {
      handler() {
        this.getCourseDetails();
      },
      deep: true,
      immediate: true,
    },
    selectedStep(newStep) {      
      if(newStep && newStep.step_type_tag === 'h5p') {
        this.$nextTick(() => {
          setTimeout(() => {
            var iframe = document.getElementById("h5pIframe");
            if(iframe) {    
              var cssLink = document.createElement("link");
              cssLink.href = this.cdnBaseUrl + "/base/app/h5p.css"; 
              cssLink.rel = "stylesheet";   
              cssLink.type = "text/css";
              frames[0].document.head.appendChild(cssLink);          
              
              setTimeout(function(){ 
                iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
              }.bind(this), 100);
            }
          }, 100);
        });
      } else if(newStep && newStep.step_type_tag === 'audio') {
        this.stepAudioEnded = false;
      } else if(newStep && newStep.step_type_tag === 'video') { 
        setTimeout(function() {
          if(newStep.step_videos[0].video_provider_tag === 'dyntube' && newStep.step_videos[0].video_available === 'Y') {
            var player = dyntube.getPlayer(newStep.step_videos[0].provider_channel_key);
            
            setTimeout(function(){
              player.on('ended', function () {
                this.stepVideoEnded = true;              
              }.bind(this));             
            }.bind(this), 100);
          }
        }.bind(this), 500);
      }
    },
    viewMode(newVal) {
      if(newVal === 'course') {        
        this.activeCourseTab = 0;
      }
    }    
  },
  mounted() {
    this.apiBaseUrl = process.env.VUE_APP_API_URL;
    this.cdnBaseUrl = process.env.VUE_APP_CDN_URL;
    this.clientToken = localStorage.getItem('token');
    if(localStorage.getItem('environmentTag') !== null) this.environmentTag = localStorage.getItem('environmentTag');

    this.$bus.$on('plyr_audio_ended', (e) => {
      this.stepAudioEnded = true;
    });    
  },
  beforeDestroy() {
    this.$bus.$off('plyr_audio_ended');
  }  
}
</script>